import React, {useState} from 'react';
import i18n from '../../i18n';
import Button from "@material-ui/core/Button/Button";
import Icon from "@material-ui/core/Icon/Icon";
import Grid from "@material-ui/core/Grid/Grid";
import Tabs from "@material-ui/core/Tabs/Tabs";
import Tab from "@material-ui/core/Tab/Tab";
import Typography from "@material-ui/core/Typography/Typography";
import Card from "@material-ui/core/Card/Card";
import CardContent from "@material-ui/core/CardContent/CardContent";
import Divider from "@material-ui/core/Divider/Divider";
import List from "@material-ui/core/List/List";
import ListItemText from "@material-ui/core/ListItemText/ListItemText";
import ListItem from "@material-ui/core/ListItem/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon/ListItemIcon";
import {withStyles} from "@material-ui/core/styles/index";
import InputLabel from "@material-ui/core/InputLabel";
import EllipsisWithTooltip from "../Formater/EllipsisWithTooltip";
import FormLabel from "@material-ui/core/FormLabel";
import Link from "@material-ui/core/Link";
import Date from "../Formater/Date";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileInvoiceDollar } from '@fortawesome/free-solid-svg-icons';
import CardHeader from "@material-ui/core/CardHeader";
import {FormattedDate, FormattedTime} from "react-intl";
import axios from "axios";
import MediaSearchField from "../Media/SearchField";
import {FormControl, Select} from "@material-ui/core";

var searchString = '', searchMachine = 0;

const CustomerDetails = (props) => {

        const {customer, notes, machines, classes} = props;
        const [appointments, setappointments] = useState(props.appointments);
        const CancelToken = axios.CancelToken;

        let cancel;

        const doSearch = (string) => {
            cancel && cancel();

            searchString = string;

            axios.get('/search-appointment-customer', {params: {'query': searchString, 'machine': searchMachine, 'customer': customer.id}, cancelToken: new CancelToken(function executor(c) {cancel = c;})}).then((response) => {
                if (response.data && response.data.length > 0) {
                    setappointments(response.data.map(item => item.entity));
                } else {
                    setappointments([]);
                }
            })
        }
        const doMachineSearch = (machineId) => {
            cancel && cancel();

            searchMachine = machineId.target.value;

            axios.get('/search-appointment-customer', {params: {'query': searchString, 'machine': searchMachine, 'customer': customer.id}, cancelToken: new CancelToken(function executor(c) {cancel = c;})}).then((response) => {
                if (response.data && response.data.length > 0) {
                    setappointments(response.data.map(item => item.entity));
                } else {
                    setappointments([]);
                }
            })
        }

        return (
            <section>
                <Grid container spacing={16}>
                    <Grid item xs={6}>
                        <Card>
                            <CardContent>
                                <Grid container spacing={8}>
                                    <Grid item xs={5}>
                                        <Typography>
                                            {i18n.get('boards.board_name')}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={7}>
                                        <Typography>
                                            {customer.customer_name}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={5}>
                                        <Typography>
                                            {i18n.get('boards.customer_number')}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={7}>
                                        <Typography>
                                            {customer.customer_number}
                                        </Typography>
                                    </Grid>
                                </Grid>

                                <Divider className={classes.gridDivider}/>

                                <Grid container spacing={8}>
                                    <Grid item xs={12}>
                                        <InputLabel
                                            component="legend">{i18n.get('boards.board_contact') + ':'}</InputLabel>
                                    </Grid>
                                    <Grid item xs={5}>
                                        <Typography>
                                            {i18n.get('boards.first_name')}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={7}>
                                        <Typography>
                                            {customer.first_name}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={5}>
                                        <Typography>
                                            {i18n.get('boards.last_name')}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={7}>
                                        <Typography>
                                            {customer.last_name}
                                        </Typography>
                                    </Grid>
                                </Grid>

                                <Divider className={classes.gridDivider}/>

                                <Grid container spacing={8}>
                                    <Grid item xs={12}>
                                        <InputLabel component="legend">{i18n.get('boards.address') + ':'}</InputLabel>
                                    </Grid>
                                    <Grid item xs={5}>
                                        <Typography>
                                            {i18n.get('boards.street')}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={7}>
                                        <Typography>
                                            {customer.street} {customer.housenumber}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={5}>
                                        <Typography>
                                            {i18n.get('boards.zip')}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={7}>
                                        <Typography>
                                            {customer.zip}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={5}>
                                        <Typography>
                                            {i18n.get('boards.city')}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={7}>
                                        <Typography>
                                            {customer.city}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={5}>
                                        <Typography>
                                            {i18n.get('boards.telephone')}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={7}>
                                        <Typography>
                                            <Link href={`tel: ${customer.telephone}`} target='_blank'>
                                                {customer.telephone}
                                            </Link>
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={5}>
                                        <Typography>
                                            {i18n.get('boards.email')}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={7}>
                                        <Typography>
                                            <Link href={`mail: ${customer.email}`} target='_blank'>
                                                {customer.email}
                                            </Link>
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={5}>
                                        <Typography>
                                            {i18n.get('boards.website')}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={7}>
                                        <Typography>
                                            <Link href={`${customer.website}`} target='_blank'>
                                                {customer.website}
                                            </Link>
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                        <Card className={classes.notes}>
                            <CardContent>
                                <Grid container spacing={8}>
                                    <Grid item xs={12}>
                                        <Typography>
                                            {i18n.get('default.notes')}
                                        </Typography>
                                    </Grid>
                                    {notes.map(note => {
                                        return (
                                            <Grid item xs={12} key={note.id}>
                                                <Card>
                                                    <CardContent>
                                                        <Grid container spacing={8}>
                                                            <Grid item xs={8}>
                                                                <Typography>
                                                                    {note.user.name}
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item xs={4}>
                                                                <Typography>
                                                                    <FormattedDate value={note.created_at}/> <FormattedTime value={note.created_at}/>
                                                                </Typography>
                                                            </Grid>

                                                            <Grid item xs={12}>
                                                                <Divider/>
                                                            </Grid>

                                                            <Grid item xs={12}>
                                                                <Typography>
                                                                    {note.note}
                                                                </Typography>
                                                            </Grid>
                                                        </Grid>
                                                    </CardContent>
                                                </Card>
                                            </Grid>
                                        )
                                    })}
                                </Grid>
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={6}>
                        <Card>
                            <CardContent>
                                <Grid container spacing={8} alignItems="center">
                                    <Grid item xs={4}>
                                        <Typography>
                                            {i18n.get('appointments.appointments')} ({appointments.length})
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={4}>
                                        <MediaSearchField
                                            searchByTyping={true}
                                            doSearch={doSearch}
                                            label={i18n.get('default.search_appointment_customer')}
                                        />
                                    </Grid>
                                    <Grid item xs={4}>
                                        <FormControl>
                                            {/*<InputLabel htmlFor="age-native-simple">Age</InputLabel>*/}
                                            <Select
                                                native
                                                name="machine"
                                                onChange={doMachineSearch}
                                            >
                                                <option value="0">--Maschine auswählen--</option>
                                                {machines.map(machine => {
                                                    return (
                                                        <option value={machine.id}>{machine.name}</option>
                                                    );
                                                })}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    {appointments.map(appointment => {
                                        return (
                                            <Grid item xs={12}>
                                                <Button variant="contained"
                                                        href={`/appointments/${appointment.id}`}
                                                        className={classes.buttonPerson}>
                                                    <Typography component='div'>
                                                        <EllipsisWithTooltip>
                                                            {appointment.appointment_name}
                                                        </EllipsisWithTooltip>
                                                    </Typography>
                                                </Button>
                                            </Grid>
                                        );
                                    })}
                                </Grid>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </section>
        )

}

const styles = {
    personCard: {
        width: '500px',
        margin: 'auto',
    },
    gridDivider: {
        marginTop: '10px',
        marginBottom: '10px',
    },
    buttonPerson: {
        width: '100%',
        margin: '5px',
    },
    cooperationCard: {
        marginTop: '15px',
    },
    notes: {
        marginTop: '15px',
    },
};

export default withStyles(styles)(CustomerDetails);



// WEBPACK FOOTER //
// ./resources/assets/js/components/Customers/CustomerDetails.js